'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = CarouselItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _list = require('../list');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Carousel Item Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
function CarouselItem(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-carousel__item': true
    }, '' + className, className));

    return (0, _jsx3.default)(_list.ListItem, {
        className: classNames,
        id: id
    }, void 0, props.children);
}
// components
//# sourceMappingURL=CarouselItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/carousel/CarouselItem.js
// module id = 553
// module chunks = 0